import React, { Component } from 'react';
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';
import classnames from 'classnames';
import NaptarTipusContent from './NaptarTipusContent.js';
import EsemenyTipusContent from './EsemenyTipusContent.js';
import CustomTooltip from '../../../components/Tooltip/CustomTooltip.js';
import getTooltip from './NaptarTooltips.js';

class NaptarBase extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: '1',
    };
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  render() {
    let cardStyle = {
      padding: 10
    };
    return (
      <div>
        <div className="animated fadeIn">
          <div className="card">
            <div className="card-header">
              Naptár
            </div>
            <div className="row" style={cardStyle}>
              <div className="col-md-12">
                <Nav tabs>
                  {(this.props.globals.hasRole(['NAPTAR_NAPTAR_ESEMENY_TIPUS'])) ?
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '1' })}
                        onClick={() => { this.toggle('1'); }}
                      >
                        Naptártípus
                        <CustomTooltip text={getTooltip('naptartipus')} id="naptartipusTT" />
                      </NavLink>
                    </NavItem>
                    : <div />}
                  {(this.props.globals.hasRole(['NAPTAR_NAPTAR_ESEMENY_TIPUS'])) ?
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '2' })}
                        onClick={() => { this.toggle('2'); }}
                      >
                        Eseménytípus
                        <CustomTooltip text={getTooltip('esemenytipus')} id="esemenytipusTT" />
                      </NavLink>
                    </NavItem>
                    : <div />}
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                  {(this.props.globals.hasRole(['NAPTAR_NAPTAR_ESEMENY_TIPUS'])) ?
                    <TabPane tabId="1">
                      <NaptarTipusContent {...this.props} globals={this.props.globals} activeTab={this.state.activeTab} />
                    </TabPane>
                    : <div />}
                  {(this.props.globals.hasRole(['NAPTAR_NAPTAR_ESEMENY_TIPUS'])) ?
                    <TabPane tabId="2">
                      <EsemenyTipusContent {...this.props} globals={this.props.globals} activeTab={this.state.activeTab} />
                    </TabPane>
                    : <div />}
                </TabContent>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default NaptarBase;
